module.exports = __webpack_public_path__ + "static/Muli-Regular-d80f1393f3ffecd0773bfee4aadfbf76.ttf";